import React from 'react'
import LoaderButton from '../../components/LoaderButton'
import FormViewer from '../../components/FormViewer'
import { translate } from '../../utils/useful'
import { siteConfig, siteTheme } from '../../variables/config'
import { loadCaptchaEnginge, LoadCanvasTemplate, LoadCanvasTemplateNoReload, validateCaptcha } from 'react-simple-captcha';


class LoginFirstStep extends React.Component {
    state = {
        key: '',
        selectedCountry: {},
        data: {},
        isLoading: false,
        formHeaders: [
            { key: 'username', type: 'TextInput', information: { label: '{{lang}}Username', icon: '/images/man.svg', placeholder: '{{lang}}Username', required: true } },
            // { key: 'family', type: 'TextInput', information: { label: '{{lang}}family', icon: 'https://image.flaticon.com/icons/svg/13/13305.svg', placeholder: '{{lang}}insertFamily', required: true } },
            { key: 'password', type: 'PasswordInput', information: { label: '{{lang}}password', icon: '/images/key.svg', placeholder: '{{lang}}password', required: true } },
            { key: 'Captcha', type: 'CaptchaInput', information: { label: '{{lang}}Captcha', captchaIcon: '/images/refresh.png', icon: '', placeholder: '{{lang}}Captcha', required: true, hint: '{{lang}}Sensitive_uperAndlower_text' } }
        ]
    }

    componentDidMount() {
        // loadCaptchaEnginge(6, '#fff', '#000', 'upper');

        // let formHeaders = [{ key: 'userIndicator', type: 'PhoneInput', information: { label: '{{lang}}phonenumber', placeholder: '{{lang}}phonenumber', required: true } }]
        // if (this.props.initData.indicatorType && this.props.initData.indicatorType === 'email') {
        //     formHeaders = [{ key: 'userIndicator', type: 'EmailInput', information: { label: '{{lang}}phonenumber', placeholder: '{{lang}}phonenumber', required: true } }]
        // }
        document.addEventListener("keydown", this._handleKeyDown);
        // this.setState({ formHeaders })
    }


    componentWillUnmount = () => {
        document.removeEventListener("keydown", this._handleKeyDown);
    }

    _handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            this.postUserIndicator()
        }
    }

    doSubmit = () => {
        let user_captcha = this.state.text;
        // let user_captcha = document.getElementById("user_captcha_input").value;

        if (validateCaptcha(user_captcha) == true) {
            alert("Captcha Matched");
            // loadCaptchaEnginge(6);
            // this.state.text = "";
            this.setState({ text: '' })
            // document.getElementById("user_captcha_input").value = "";
        } else {
            alert("Captcha Does Not Match");
            this.setState({ text: '' })
            // document.getElementById("user_captcha_input").value = "";
            // document.getElementById("user_captcha_input").value = "";
        }
    };


    postUserIndicator = () => {
        let data = this.form.getForm()
        // let user_captcha = this.state.text;
        // let user_captcha = document.getElementById("user_captcha_input").value;

        if (data) {
            this.setState({ isLoading: true, errors: {} })
            this.props.setData(data, () => {
                this.props.postUserIndicator((result, err) => {
                    if (err) { this.setState({ isLoading: false, errors: err }) }
                    this.setState({ isLoading: false })
                })
            })
        }
        // if (validateCaptcha(user_captcha) == true && data) {
        //     alert("Captcha Matched");
        //     // loadCaptchaEnginge(6);
        //     // this.state.text = "";
        //     this.setState({ text: '' })
        //     // document.getElementById("user_captcha_input").value = "";
        //     // if (data) {
        //     this.setState({ isLoading: true, errors: {} })
        //     this.props.setData(data, () => {
        //         this.props.postUserIndicator((result, err) => {
        //             if (err) { this.setState({ isLoading: false, errors: err }) }
        //             this.setState({ isLoading: false })
        //         })
        //     })
        //     // }
        // } else {
        //     alert("Captcha Does Not Match");
        //     this.setState({ text: '' })
        //     // document.getElementById("user_captcha_input").value = "";
        //     // document.getElementById("user_captcha_input").value = "";
        // }
    }

    render() {
        return (
            <div className="flexcc flex-column">

                <div className='flexcc'>
                <img className=" mb-2" src={siteTheme.logo} width={'100px'} />
                
                {/* <p className='font-weight-bold text-white' > نارون</p> */}
                </div>
                {/* <h1 className="text-ultra-big white">{siteConfig.siteName}</h1> */}

                {/* {this.props.settings.mode === 'forgotPassword' ? (
                    <h2 className="mt-4 " style={{ fontSize: 27 }}>Forgot Password</h2>
                ) : (
                    <div className='w-100 text-center'>
                        <h2 className="mt-3 mb-0" style={{ fontSize: 27, whiteSpace: 'nowrap', color: '#005249' }}>{siteConfig.siteName}</h2>
                    </div>
                )} */}
                {/* <h2 className="mt-1 mb-0" style={{ fontSize: 24, whiteSpace: 'nowrap', color: '#fff', }}>{siteConfig.siteName}</h2> */}
                <h2 className="mt-0 mb-4" style={{ fontSize: 20, whiteSpace: 'nowrap', color: '#fff', letterSpacing: 0, opacity: 0.4 }}>{translate('CRM panel')}</h2>

                <div className="w-100" style={{ maxWidth: 400 }}>

                    <FormViewer ref={el => this.form = el} headers={this.state.formHeaders} initData={this.props.initData} loginError={this.props.loginError} errors={this.state.errors} inputClass={'modern-input'} />
                    {/* <div className='test' style={{}}>

                        <LoadCanvasTemplate reloadText={`<img src='/images/icons8-refresh-100.png' width='20px' />`} />
                    </div>
                    {console.log('text ==>', this.state.text)}
                    <input
                        placeholder="Enter Captcha"
                        onChange={(e) => this.setState({ text: e.target.value })}
                        name="user_captcha_input"
                        type="text"
                    /> */}
                    {/* <input
                        placeholder="Enter Captcha"
                        id="user_captcha_input"
                        name="user_captcha_input"
                        type="text"
                    ></input> */}

                    <div className="text-center">
                        <LoaderButton
                            onClick={this.postUserIndicator}
                            isLoading={this.state.isLoading}
                            text={translate('send')}
                            type={"Oval"}
                            className="w-100 mt-4 mb-4"
                            buttonStyle={{ outline: 'none', backgroundColor: '#000', cursor: 'pointer', padding: '10px 50px', borderRadius: 40, fontSize: 15, fontWeight: 'bold', color: '#fff', border: 'none' }}
                            width={80}
                            height={70}
                            color={'#202020'}
                        />
                        {/* <p style={{ fontSize: 15, margin: '10px 20px 20px' }}>{translate("insert-phone-desc")}</p> */}

                        <p style={{ fontSize: 13, opacity: 0.5, marginTop: 10, color: '#fff' }}>{translate('cookie-warning')}</p>
                    </div>
                </div>
            </div>
        )
    }
}

export default LoginFirstStep